import { ICanvas, IRenderer } from 'pixi.js'

/**
 * Helper function to get the game size in pixels based on the renderer's resolution.
 * @author Adam Drake - <adam.drake@1x2network.com>
 * @version 1.0.0
 */

export function getGameSizeInPixels(renderer: IRenderer<ICanvas>): { width: number; height: number } {
    const { height, width, resolution } = renderer
    return { width: width / resolution, height: height / resolution }
}
